import { KYMW1002Model } from '../kymw1002.model';
import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 関連会社IDを更新するサービス
 *
 * @export UpdateAssociatedCompanyIdService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class UpdateAssociatedCompanyIdService extends PlessJsonResponderSub<string> {

  // 処理に使用するModel
  public model: KYMW1002Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof UpdateAssociatedCompanyIdService
   */
  private successFunc: Function;

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetDashboardLockInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        UpdateAssociatedCompanyId: {
          condition: {
            SupplierCode: this.model.supplierCode
          }
        }
      }
    });
  }

  /**
   *   /**
   * API呼び出し
   *
   * @memberof UpdateAssociatedCompanyIdService
   * @param model
   * @param successFunc 
   */
  execute(model: KYMW1002Model, successFunc: Function): void {
    this.model = model;
    this.successFunc = successFunc;
    this.send('updateAssociatedCompanyId', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof UpdateAssociatedCompanyIdService
   */
  success(): void {
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }
}

